import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { useNavigate, useParams } from 'react-router-dom';

import PropTypes from 'prop-types';

import ClientDetailsComponent from '@/components/ClientsPage/ClientDetails/ClientDetailsComponent';
import { useClients } from '@/hooks/useClients';
import { reloadCards } from '@/store/ducks/cards';
import { showToast } from '@/store/ducks/toasts';

const ClientDetailsContainer = () => {
  const numberFormat = new Intl.NumberFormat('pt-BR', {
    maximumSignificantDigits: 5,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, status } = useParams();
  const intl = useIntl();
  const { useClientDetails, useUpdateClientStatusMutation } = useClients();
  
  const { data: client, isLoading } = useClientDetails(id);
  const updateStatus = useUpdateClientStatusMutation(id);

  useEffect(() => {
    if (client) {
      const clientStatus = client?.details?.status;
      if (status === 'enabled' && clientStatus === 'DISABLED') {
        navigate(`/clients/disabled/${id}`, { replace: true });
      } else if (status === 'disabled' && clientStatus === 'ENABLED') {
        navigate(`/clients/enabled/${id}`, { replace: true });
      }
    }
  }, [client, id, navigate, status]);

  const disableClient = async () => {
    updateStatus.mutate({ isDisabled: true }, {
      onSuccess: () => {
        navigate(`/clients/${status}`);
        dispatch(reloadCards());
      },
      onError: () => {
        dispatch(showToast({
          type: 'error',
          title: intl.formatMessage({ id: 'ERROR' }),
          text: intl.formatMessage({ id: 'CUSTOMER_DEACTIVATION_ERROR' }),
          duration: 5000,
        }));
      }
    });
  };

  const enableClient = async () => {
    updateStatus.mutate({ isDisabled: false }, {
      onSuccess: () => {
        navigate(`/clients/${status}`);
        dispatch(reloadCards());
      },
      onError: () => {
        dispatch(showToast({
          type: 'error',
          title: intl.formatMessage({ id: 'ERROR' }),
          text: intl.formatMessage({ id: 'CUSTOMER_ACTIVATION_ERROR' }),
          duration: 5000,
        }));
      }
    });
  };

  return (
    <ClientDetailsComponent
      client={client}
      disableClient={disableClient}
      enableClient={enableClient}
      id={id}
      intl={intl}
      numberFormat={numberFormat}
      status={status}
      loading={isLoading}
    />
  );
};

export default ClientDetailsContainer;

